var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 200,
  className: "close_svg__icon",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m801.646 170.667 51.834 51.59L565.15 511.95l288.354 289.67-51.834 51.615-288.11-289.45-288.134 289.45-51.834-51.615 288.33-289.67-288.33-289.694 51.834-51.59 288.11 289.426z"
})));
export default SvgClose;